const canonicalId = (value: string) => `${value}`.toLowerCase().trim();

export default canonicalId;
